module.exports = __webpack_public_path__ + "img/provada.1560e274.png";